import { getFirestore, doc, deleteDoc } from "firebase/firestore";

export default async function destroyFromInstance(collection: string, ref: string) {

    const documentRef = doc(getFirestore(), `${collection}/${ref}`);
    return deleteDoc(documentRef);
}
